// "Mark as upcoming" for an event in Passed (Jade, 2026-11-02): pick a new date
// to move it to (it goes back to Passed by itself once that date has gone by),
// or "Keep in Upcoming" on its own date, where it stays until "Mark as passed"
// is tapped. Rules in utils/eventStatus.js.
import React from "react";
import { CalendarClock } from "lucide-react";
import Modal from "../../components/Modal";
import ConfirmHeader from "../../components/ConfirmHeader";
import { MonthPicker } from "./DatePickParts";
import { CONFIRM_COLUMN, CONFIRM_PRIMARY, CONFIRM_CANCEL, SKIP_CAL_SHADOW } from "../../theme/sharedStyles";
import { todayStr } from "../../utils/dateHelpers";

const niceDate = (ds) => {
  if (!ds) return "";
  const [y, m, d] = ds.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString(undefined, { month: "short", day: "numeric", year: y !== new Date().getFullYear() ? "numeric" : undefined });
};

export function MarkUpcomingPanel({ title, date, weekStart = "sunday", onMove, onKeep, onClose }) {
  const today = todayStr();
  const [pick, setPick] = React.useState(today);
  const canMove = pick && pick >= today;
  return (
    <Modal onClose={onClose} animate={false} zIndex={100200}>
      <div onClick={e => e.stopPropagation()}
        style={{ background: "var(--c-bg-card)", borderRadius: 20, padding: "22px 18px 18px", width: "100%", maxWidth: 360, boxShadow: "0 10px 44px rgba(0,0,0,0.22)", fontFamily: "'Quicksand','Nunito',sans-serif" }}>
        <ConfirmHeader tone="accent" compact icon={CalendarClock} title={`Mark "${title}" as upcoming?`}
          subtitle="Pick a new date for it, or keep it in Upcoming." />
        <div style={{ borderRadius: 16, padding: "10px 8px", boxShadow: SKIP_CAL_SHADOW, marginBottom: 16 }}>
          <MonthPicker start={pick} weekStart={weekStart} onPick={setPick} />
        </div>
        <div style={CONFIRM_COLUMN}>
          <button disabled={!canMove} onClick={() => canMove && onMove(pick)}
            style={{ ...CONFIRM_PRIMARY, opacity: canMove ? 1 : 0.5, cursor: canMove ? "pointer" : "default" }}>
            {canMove ? `Move to ${niceDate(pick)}` : "Pick today or a later date"}
          </button>
          <button onClick={onKeep} style={CONFIRM_CANCEL}>Keep in Upcoming</button>
          <button onClick={onClose}
            style={{ border: "none", background: "transparent", color: "var(--c-text-soft)", fontFamily: "inherit", fontSize: 13.5, fontWeight: 700, cursor: "pointer", padding: "4px 0", minHeight: 0 }}>
            Cancel
          </button>
        </div>
        <div style={{ marginTop: 10, fontSize: 11.5, color: "var(--c-text-soft)", textAlign: "center", lineHeight: 1.45 }}>
          Keep in Upcoming leaves it on {niceDate(date)}. It stays in Upcoming until you tap Mark as passed.
        </div>
      </div>
    </Modal>
  );
}
